// extracted by mini-css-extract-plugin
module.exports = {"store":"style_store__KTtWA","category":"style_category__25YoA","items":"style_items__3OyWX","lineThrough":"style_lineThrough__3HGS4"};